export default __webpack_public_path__ + "static/media/da.6a320b13.jpg";